import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgN600MonteCarlo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 500 500",
	style: { enableBackground: "new 0 0 500 500" },
	xmlSpace: "preserve",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		className: "st0",
		d: "M358,346.83h-2.19c-1.77-0.28-30.94-6.48-48.51-98.45c-12.9-67.54-27.58-112.52-57.29-112.53c0,0,0,0,0,0 c0,0,0,0-0.01,0c-29.7,0.01-44.38,44.99-57.29,112.53c-17.55,91.86-46.68,98.15-48.51,98.45H142c-4.78,0-8.66,3.88-8.66,8.66 s3.88,8.66,8.66,8.66h2.51c3.2,0,24.55-1.63,44.08-42.71v34.05c0,4.78,3.88,8.66,8.66,8.66c4.78,0,8.66-3.88,8.66-8.66v-85.94 c1.33-5.64,2.6-11.59,3.81-17.92c3.99-20.91,14.99-78.48,31.61-94.35v198.21c0,4.78,3.88,8.66,8.66,8.66s8.66-3.88,8.66-8.66V157.27 c16.62,15.87,27.62,73.45,31.61,94.35c1.21,6.33,2.48,12.28,3.81,17.92v85.94c0,4.78,3.88,8.66,8.66,8.66s8.66-3.88,8.66-8.66 v-34.05c19.53,41.09,40.88,42.71,44.08,42.71H358c4.78,0,8.66-3.88,8.66-8.66S362.78,346.83,358,346.83z M144.28,346.83 c0.15-0.01,0.23,0,0.23,0H144.28z M355.72,346.83h-0.23C355.49,346.83,355.57,346.82,355.72,346.83z"
	})]
});
const ForwardRef = forwardRef(SvgN600MonteCarlo);
export { ForwardRef as ReactComponent };
